import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { DataHelper, DownloadHelper, HttpHelper, UrlHelper } from '@helpers';
import {
    EmitterService,
    RedirectService,
    StorageService,
    TranslateService,
} from '@services';
import { PlayerService } from 'src/app/services/player.service';
import { environment as env, environment } from '@env/environment';
import { take } from 'rxjs';
import { ContentProvider, InstanceProvider, TemplateProvider } from '@lighty';
import { CommonToastService } from '@common2/services/toast.service';
import { el } from 'date-fns/locale';

@Component({
    selector: 'msc-learn-detail-instance-presentation',
    templateUrl: './presentation.component.html',
    styleUrls: ['./presentation.component.scss'],
})
export class LearnDetailInstancePresentationComponent implements OnInit {
    public instance: any;
    public company: any;
    public ratingInfo: any;
    public ratingComments: any[] = [];
    public saved: boolean = false;
    public subscribed: boolean = false;
    public message: string;
    public account: any;
    public summary: any;
    public isSubscribing: boolean = false;
    public processing: boolean = false;
    public isLoaded: boolean = false;
    public courseProgress: number = 0;
    // Nota final / score general del curso (misma fuente de reporting que el progreso).
    public courseScore: number = 0;

    constructor(
        private route: ActivatedRoute,
        private emitterService: EmitterService,
        private redirectService: RedirectService,
        private playerService: PlayerService,
        private storageService: StorageService,
        private contentProvider: ContentProvider,
        private translateService: TranslateService,
        private toastService: CommonToastService,
        private instanceProvider: InstanceProvider,
        private router: Router,
        private templateProvider: TemplateProvider,
        private location: Location,
    ) { }

    goBack(): void {
        this.location.back();
    }

    ngOnInit(): void {
        //this.summary = this.route.snapshot.data.summary;
        /* console.log('router', this.route);
         this.instance = this.route.parent.snapshot.data.instance;
         console.log('instance', this.instance);
         this.company = this.storageService.get('company');
         this.instance = this.getInstanceRemapped(this.instance);
         this.account = this.route.snapshot.data.instance.account;
         console.log('account', this.account);
         console.log('router data', this.route)
         this.getRatingInfo();
         this.summary = this.instance.summary;*/

        this.route.data.subscribe(data => {
            console.log('router data', data);

            this.instance = this.getInstanceRemapped(data.instance);
            this.account = data.instance.account;
            this.summary = this.instance.summary;
            this.subscribed = this.instance.subscribed;
            this.company = this.storageService.get('company');
            this.getRatingInfo();
            const navState = history.state;
            if (typeof navState?.progress === 'number') {
                this.courseProgress = navState.progress;
            }
            // Siempre consulta el reporting para obtener progreso + nota final (score) autoritativos.
            this.getProgress();
            //saved
            this.saved = !!this.instance.saved;
            this.isLoaded = true;

        });

        // Si necesitas reaccionar al cambio de parámetro en la URL también
        this.route.paramMap.subscribe(params => {
            const instanceId = params.get('instanceyId');
            console.log('Instance ID actual:', instanceId);
            // Podrías hacer algo con el ID aquí si lo necesitas aparte del resolver
        });
    }

    downloadIcs(ics: any): void {
        DownloadHelper.download(ics, '', false);
    }

    start(): void {
        if (
            !DataHelper.isEmpty(this.instance.playerLight) &&
            this.instance.playerLight.context === 'internal'
        ) {
            this.emitterService.set('player-light.open', {
                type: this.instance.playerLight.type,
                content: this.instance.playerLight,
                more: this.instance,
            });
        } else if (
            !DataHelper.isEmpty(this.instance.playerLight) &&
            this.instance.playerLight.context === 'external_link'
        ) {
            this.emitterService.set('player-light.open', {
                type: 'activity',
                subscriptionCourseId: this.instance.id,
                more: this.instance,
            });
        } else {
            this.redirectService.navigate('player', [
                'course',
                this.instance.id,
            ]);
        }
    }

    getInstanceRemapped(datum: any) {
        const mediaUrl = this.getMediaUrl(datum);
        return { mediaUrl, ...datum };
    }

    getMediaUrl(datum: any): string {
        let rawUrl: string;

        if (datum?.picture) {
            const providerKey = datum?.provider?.key;
            const suffix = providerKey !== 'linkedin' ? '?size=512' : '';
            rawUrl = `${datum.picture}${suffix}`;
        } else if (datum?.provider?.media?.pictureUrl) {
            rawUrl = `${datum.provider.media.pictureUrl}?size=256`;
        } else {
            rawUrl = `https://static.myskillcamp.com/lxp/images/logo-empty-state-${(datum?.id ?? 0) % 7}.webp`;
        }

        if (!environment.production && rawUrl.includes('api-upgraded.myskillcamp.com.deltabluecdn.com')) {
            rawUrl = rawUrl.replace('https://api-upgraded.myskillcamp.com.deltabluecdn.com', 'https://api.myskillcamp.com');
        }

        return `url(${rawUrl})`;
    }

    private getPlayerBaseUrl(): string {
        const localUrl = UrlHelper.getProtocol() + '//' + UrlHelper.getHost();
        const isDevOrDefault = env.name.short === 'dev' ||
            `${UrlHelper.getHostname()}/` === env.envVar.APP_URL.replace('https://', '').replace('http://', '');
        const base = isDevOrDefault ? env.envVar.PLAYER_URL : `${localUrl}/player`;
        return base.replace(/\/$/, '');
    }

    openIframe(isTemplate?: boolean): void {
        const playerBaseUrl = this.getPlayerBaseUrl();
        if (isTemplate) {
            const url = `${playerBaseUrl}/course/${this.instance.courseCamps[0].courseId}`;
            console.log('Opening iframe with URL for template:', url);
            this.playerService.openIframe(url);
        } else {
            let url = `${playerBaseUrl}/course/${this.instance.id}`;
            if (this.instance.subscribed && this.instance.schema === 'template') {
                url = `${playerBaseUrl}/course/${this.instance.subscribedTo}`;
            }
            console.log('Opening iframe with URL for instance:', url);
            this.playerService.openIframe(url);
        }
        this.processing = false;
    }

    public convertSecondsToHoursMinutes(seconds: number): string {
        if (seconds < 0 || isNaN(seconds)) {
            return '0h0m';
        }

        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);

        return `${hours}h${minutes}m`;
    }

    public getProgress(): void {
        const params = { company_id: this.company.id, per_page: 200 };
        this.contentProvider
            .getContents(params)
            .pipe(take(1))
            .subscribe({
                next: ({ contents }) => {
                    const match = contents.find((c: any) => c.data?.id === this.instance.id);
                    this.courseProgress = match?.data?.progress ?? 0;
                    this.courseScore = match?.data?.score ?? 0;
                },
                error: () => {
                    this.courseProgress = 0;
                    this.courseScore = 0;
                }
            });
    }

    public getRatingInfo(): void {
        const params = {
            contentId: this.instance.id,
            contentType: 'course',
        };
        this.contentProvider
            .getContentRating(this.company.id, params)
            .pipe(take(1))
            .subscribe((data) => {
                this.ratingInfo = data;
            });
    }

    public handleRating(data: {
        rating: number;
        comment: string;
        isFirstTime: boolean;
    }): void {
        const params = {
            contentId: this.instance.id,
            contentType: 'course',
            rating: data.rating,
            comment: data.comment,
        };

        if (this.ratingInfo.userRating === null) {
            this.contentProvider
                .rateContent(this.company.id, params)
                .pipe(take(1))
                .subscribe((response) => {
                    this.toastService.onSuccess(
                        this.translateService.instant('toast.rating-success')
                    );
                    this.getRatingInfo();
                    this.getRatingComments();
                });
        } else {
            this.contentProvider
                .rateContentUpdate(
                    this.company.id,
                    params,
                    this.ratingInfo.userRatingId
                )
                .pipe(take(1))
                .subscribe((response) => {
                    this.toastService.onSuccess(
                        this.translateService.instant(
                            'toast.rating-update-success'
                        )
                    );
                    this.getRatingInfo();
                    this.getRatingComments();
                });
        }
    }

    public getRatingComments(): void {
        this.ratingComments = [];
        const params = {
            contentId: this.instance.id,
            contentType: 'course',
        };
        this.contentProvider
            .getRatingsComments(this.company.id, params)
            .pipe(take(1))
            .subscribe((data) => {
                this.ratingComments = data.comments;
                console.log('rating comments', this.ratingComments);
            });
    }

    public getStars(rating: number): number[] {
        return Array(rating).fill(0);
    }

    public clipboard(): void {
        if (this.company.customUrl) {
            if (this.company.customUrl.slice(-1) === '/') {
                DataHelper.clipboard(
                    `${this.company.customUrl}${location.pathname.substring(1)}`
                );
            } else {
                DataHelper.clipboard(
                    `${this.company.customUrl}${location.pathname}`
                );
            }
        } else {
            DataHelper.clipboard(location.href);
        }
        this.toastService.onSuccess(
            this.translateService.instant('toast.link-clipboard')
        );
    }
    //save course
    addToSavedContents(): void {
        this.instance.saved = true;

        const params = {
            context: 'course_template',
            context_id: this.instance.id
        };

        this.contentProvider.addSavedContent(params).subscribe(() => {
            this.toastService.onSuccess(this.translateService.instant('toast.learn-later.saved'));
        });
    }

    deleteSavedContent(): void {
        this.instance.saved = false;

        const params = {
            context: 'course_template',
            context_id: this.instance.id
        };

        this.contentProvider.deleteSavedContent(params).subscribe(() => {
            this.toastService.onSuccess(this.translateService.instant('toast.learn-later.deleted'));
        });
    }


    public changeLearnLaterContent(): void {
        this.saved = !this.saved;
        this.instance.saved = this.saved;

        const params = {
            context: 'course_template',
            context_id: this.instance.id
        };

        if (this.saved) {
            this.contentProvider.addSavedContent(params).subscribe(() => {
                console.log('saving');
                this.toastService.onSuccess(this.translateService.instant('toast.learn-later.saved'));
            });
        } else {
            this.contentProvider.deleteSavedContent(params).subscribe(() => {
                console.log('deleting');
                this.toastService.onSuccess(this.translateService.instant('toast.learn-later.deleted'));
            });
        }
    }




    public deleteContent(data): void {
        const params = HttpHelper.cleanParams({
            message: this.message,
        });

        this.instanceProvider
            .unsubscribe(this.instance.id, params)
            .subscribe(() => {
                this.toastService.onSuccess(
                    this.translateService.instant('toast.unregister')
                );
                this.router.navigate(['/learn', this.company.slug, 'contents']);
            });
    }

    public openConversation(): void {
        this.storageService.set('conversationUsers', [this.account]);
        this.router.navigate(['conversation', 'create']);
    }

    public subscribeToContent(): void {
        if (!this.isLoaded) {
            console.error('Instance not loaded yet');
            this.toastService.onError('Error: Datos del curso no cargados. Por favor espere.');
            return;
        }
        if (!this.instance?.courseCamps || this.instance.courseCamps.length === 0) {
            console.error('courseCamps not found', this.instance);
            this.toastService.onError('Error: No se encontraron campañas del curso.');
            return;
        }
        this.isSubscribing = true;
        this.processing = true;
        const params = HttpHelper.cleanParams({
            course_camp_id: this.instance.courseCamps[0].id
        });

        this.templateProvider.subscribe(params).subscribe((data) => {
            console.log('Subscribe response:', data);
            this.subscribed = true;
            this.instance.subscribed = true;
            // Copiar playerLight del courseCamp a instance para que playContentCourse lo encuentre
            if (this.instance?.courseCamps && this.instance.courseCamps.length > 0) {
                this.instance.playerLight = this.instance.courseCamps[0].playerLight;
                this.instance.subscribedTo = this.instance.courseCamps[0].courseId;
            } else {
                this.instance.subscribedTo = data?.id || data?.subscription_id || data?.course_subscription_id;
            }
            this.toastService.onSuccess(this.translateService.instant('toast.demand-sent'));
            // Siempre llamar a playContentCourse para SCORM y otros tipos
            this.playContentCourse();
        }, (failure) => {
            if (failure.status === 403) {
                this.toastService.onSuccess(this.translateService.instant(`toast.${failure.error.translationKey}`));
            }
        });
    }

    public getCompanyLogo(): string {
        const rawUrl = this.instance?.picture;
        let url = rawUrl ? `${rawUrl}?size=256` : 'https://webservices.griky.co/cdn/img/Griky-Logotipo.webp';

        if (!environment.production && rawUrl) {
            url = url.replace(
                "https://api-upgraded.myskillcamp.com.deltabluecdn.com",
                "https://api.myskillcamp.com"
            );
        }

        return url;
    }

    /**
     * Acción del botón "Comenzar".
     * Si el usuario aún NO está inscrito en el curso, primero lo inscribe (mismo flujo que
     * el botón "Inscribirse") y luego reproduce, evitando el "Access denied"
     * (not subscribed to course) que ocurría al abrir el player sin inscripción previa.
     * Si ya está inscrito, reproduce directamente.
     */
    public startContent(): void {
        if (!this.instance?.subscribed && !this.subscribed) {
            this.subscribeToContent();
        } else {
            this.playContentCourse();
        }
    }

    public playContentCourse(): void {
        console.log('playContentCourse', this.instance);
        
        // Determinar playerLight según si está subscripto o no
        let playerLight = null;
        let moreData = null;
        
        if (this.instance?.subscribed) {
            playerLight = this.instance?.playerLight;
            moreData = this.instance;
            console.log('instance subscribed - usando this.instance.playerLight');
        } else {
            playerLight = this.instance?.courseCamps?.[0]?.playerLight;
            moreData = this.instance?.courseCamps?.[0];
            console.log('instance NOT subscribed - usando courseCamps[0].playerLight');
        }
        
        console.log('playerLight:', playerLight, 'moreData:', moreData);
        
        // Verificar si es SCORM (tiene scormId)
        if (playerLight?.scormId) {
            console.log('Es SCORM, scormId:', playerLight.scormId);
            this.emitterService.set('player-light.open', {
                type: 'iframe',
                content: {
                    sectionContentId: playerLight.sectionContentId,
                    scormId: playerLight.scormId,
                    scormCourseId: playerLight.scormCourseId
                },
                more: moreData || this.instance,
            });
        } else if (playerLight && playerLight.context === 'external_link') {
            console.log('External link activity');
            this.emitterService.set('player-light.open', {
                type: 'activity',
                subscriptionCourseId: this.instance?.id,
                more: this.instance,
            });
        } else if (playerLight && !DataHelper.isEmpty(playerLight) && playerLight.context === 'internal') {
            console.log('Course genérico con playerLight context internal');
            this.emitterService.set('player-light.open', {
                type: playerLight.type,
                content: playerLight,
                more: moreData || this.instance,
            });
        } else {
            console.log('Iframe genérico (sin playerLight o sin scormId)');
            this.openIframe(!this.instance?.subscribed);
        }
    }
}
